/** Right-aligned user input bubble. Brand-blue fill + foreground text. */
export function UserMessage({ text }: { text: string }) {
  return (
    <div className="flex justify-end">
      <div className="bg-accent-main text-primary-foreground max-w-[80%] rounded-xl px-3 py-2 text-xs leading-5">
        {text}
      </div>
    </div>
  );
}
